import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const QUERY = `*[_type == "teamMember" && group == "board"] | order(order asc) {
  _id, name, title, photo
}`;

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    { breakpoint: 5000, settings: { slidesToShow: 4, slidesToScroll: 2, infinite: false, dots: false } },
    { breakpoint: 1600, settings: { slidesToShow: 4, slidesToScroll: 2, infinite: false, dots: false } },
    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 2, infinite: false, dots: false } },
    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

export default function CarouselTeam() {
  const { data, loading } = useSanityQuery(QUERY);

  if (loading || !data || data.length === 0) return <div />;

  return (
    <div className='slickteam'>
      <Slider {...settings}>
        {data.map((member) => (
          <div className='itm' key={member._id}>
            <div className='bg'>
              {member.photo?.asset && (
                <img
                  src={urlFor(member.photo).width(400).height(400).url()}
                  className="img-fluid"
                  alt={member.name}
                  style={{ width: '400px', height: '400px', objectFit: 'cover' }}
                />
              )}
            </div>
            <div className='desc'>
              <div className='name'>{member.name}</div>
              <div className='title'>{member.title}</div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
